exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "li.artist[data-v-e766e5e2]{display:inline-block;padding:5px;margin:10px;border:2px solid #41b883;border-radius:5px}img[data-v-e766e5e2]{border-radius:5px}h2.name[data-v-e766e5e2]{text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e766e5e2","scoped":true,"hasInlineConfig":false}!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/artist.vue
// module id = 13
// module chunks = 0